export default {
  elementType: null,
  activeID: {
    container_id: 0, //画布id
    rect_id: null, //组件的id
    uid: null, //col的id
    elementInLayoutId: null, //col里的组件的id
    directionIndex: null, //四个方向的id
    swiperContent_id: null, //轮播的每一页的id
    elementInSwiperId: null, //轮播组件的一页里的组件的id
    elementInAutoLayoutId: null, //自动布局组件的id
    pageLayoutId: null, // 页面通栏的位置
  },
  activeGridId:null, // 激活的栅格的id
  toolBarStatus: true,
  alignHelperStatus: false,
  dragMode: false, //轮播模式控制，false编辑模式  true预览模式
  getDataPageIds: {
    // appId: 123,
    // wfwfid: 12312,
    // websiteId: 312,
    // pageId: 12312,
    // typeId: 1231241323,
    // sign: 'f5a43798972ac143312a0d8486abd052'
  },
  showRightBtn: false,
  showLeftMenu: false,
  dragStatus: false,
  leftMenuDragStatus: false, // 是否正在拖拽左侧菜单的组件
  showRightMenu: false,
  showPluginSetting: false,
  showRuler: true,
  showLeftMenus: true, //showLeftMenu逻辑有差异，所以新加属性，后期视情况是否删除
  showRightToolbar: false,
  showComponentName: false, // 是否显示组件名称
  showPhoneLayer: false, // 翻页模版显示图层
  managerType: 0,
  showEditShape: false, // 是否有复杂组件是聚焦状态
  showAllScreen: false, // 页面100%显示，并且两侧面板悬浮起来
  userInfo: null,
  logicTextDynamicId: "", // 当前激活的逻辑文本的变量id或者动态数据id
  isUpdateLayerDataFlag: false, // 是否更新图层数据,在编辑模式下，新增元素，删除元素，新增画布，删除画布，交换画布均会更新图层数据
  pageList: [],
  userPermission: 0, // 上传样式到系统   0|1 无权限   11 上传权限   12删除权限
  editPageThemeColor: 0, //编辑页风格
  editPageThemeColorList: ["#ffffff", "#E25E5D", "#FF8D3A", "#008585", "#3D82F2"],
  zoom: 1, //编辑页的比例，按照可视区域和1920的比例计算
  zoomActual: 1, // 实际的页面缩放比例
  weatherAndDate: null,
  isClonePattern: false, // 是否开启单元格 克隆模式
  isOrderPattern: false, // 是否开启单元格 排序模式
  historyState: [], // 撤销、重做历史状态记录
  historyIndex: -1, // 撤销、重做索引位置
  // managerType: 0 // 0 普通用户  1 专业版（开启之前的admin模式） 取消这种模式，直接用按钮控制
  loadingSyncPlugins: true, // 同步插件加载状态
  // 子页面编辑状态，edit表示是否正在编辑，type表示编辑类型：setting: 设置，template: 模板
  subPageEditInfo: {
    edit: false,
    type: "setting",
    value: ""
  },
  scrollLeft:0 // 中间滚动条的位置
}
